"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionSpinsBuyFeatureView = void 0;
const PromoPanelAssetConfig_1 = require("../../../config/PromoPanelAssetConfig");
const NolimitPromotionPlugin_1 = require("../../../NolimitPromotionPlugin");
const PromoPanelLabelIDs_1 = require("../../../enums/PromoPanelLabelIDs");
const PromoPanelTextStyles_1 = require("../../../config/PromoPanelTextStyles");
const FeatureBasePanel_1 = require("../../FeatureBasePanel");
const NolimitApplication_1 = require("@nolimit/slot-launcher/bin/NolimitApplication");
const Helper_1 = require("../../../utils/Helper");
const FeatureBuyTicket_1 = require("../../../components/FeatureBuyTicket");
const PromoPanelConfig_1 = require("../../../config/PromoPanelConfig");
const ImgLoader_1 = require("@nolimit/slot-launcher/bin/loader/ImgLoader");
const ASEnums_1 = require("../../../enums/ASEnums");
const CurrencyUtils_1 = require("../../../utils/CurrencyUtils");
class ActionSpinsBuyFeatureView extends FeatureBasePanel_1.FeatureBasePanel {
    constructor(controller) {
        super(PromoPanelAssetConfig_1.PromoPanelAssetConfig.NOLIMIT_BONUS_ICON, NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.ACTION_SPINS_BONUS_BUY), PromoPanelTextStyles_1.PromoPanelTextStyles.FEATURE_BASE_BUY_FEATURE_TITLE);
        this._featureBuyTickets = [];
        this._controller = controller;
        this._featureContainer = new PIXI.Container();
        this._featureContainer.name = "AS_FEATURE_CONTAINER";
    }
    onBalanceUpdate(balance) {
        var _a;
        (_a = this._featureBuyTickets) === null || _a === void 0 ? void 0 : _a.forEach((gameFeatureView) => {
            gameFeatureView.updateButtons();
        });
    }
    onGameOptionsUpdate(selectedOptions) {
        var _a;
        const config = NolimitPromotionPlugin_1.NolimitPromotionPlugin.ASOptionsData;
        (_a = this._featureBuyTickets) === null || _a === void 0 ? void 0 : _a.forEach((gameFeatureView) => {
            gameFeatureView.allowedByOptions = true;
            if (config.bonusGame) {
                if (config.bonusGame.pickNeededForBuyFeatures.indexOf(gameFeatureView.featureData.name) > -1) {
                    //Needs option pick.
                    const selection = selectedOptions.get(config.bonusGame.type);
                    if (selection == undefined) {
                        gameFeatureView.allowedByOptions = false;
                    }
                }
            }
            gameFeatureView.updateButtons();
        });
    }
    init() {
        if (!this._init) {
            this.addChild(this._featureContainer);
            this._init = true;
        }
    }
    /**
     * To create feature list view. only FEATURE_FILTER_LIST have feature list will be created.
     *
     */
    createGameFeatureList(bonusFeatures) {
        this._featureContainer.removeChildren();
        this._featureBuyTickets.length = 0;
        const buyButtonTexture = ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.ACTION_SPINS_BUY_BTN);
        for (let featureData of bonusFeatures) {
            const gameFeatureView = new FeatureBuyTicket_1.FeatureBuyTicket(featureData, (button, featureData) => this._controller.buttonClick(button, featureData), buyButtonTexture);
            this._featureContainer.addChild(gameFeatureView);
            this._featureBuyTickets.push(gameFeatureView);
        }
    }
    close(isSelfClose = true) {
        this.closePopUp();
        if (isSelfClose) {
            super.close();
        }
    }
    openPopUp(featureData) {
        var _a, _b;
        const bet = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
        const totalCost = (+bet * featureData.price);
        const popUpData = {
            isBonusBuy: true,
            bet: CurrencyUtils_1.CurrencyUtils.formatWithDecimalCutOff(totalCost),
            featureData: featureData,
            image: featureData.name,
            rounds: this._controller.actionSpinsController.spinsLeft
        };
        popUpData.stopOnBonus = false;
        popUpData.options = [];
        const rowOption = this._controller.actionSpinsController.view.gameOptionsView.selectedOptions.get(ASEnums_1.ASBonusPickOptions.ROW_OPTIONS);
        if (rowOption) {
            popUpData.options.push(rowOption);
        }
        let isPickApplicableToSelectedFeatureBuy = true;
        if ((_b = (_a = NolimitPromotionPlugin_1.NolimitPromotionPlugin.ASOptionsData) === null || _a === void 0 ? void 0 : _a.bonusGame) === null || _b === void 0 ? void 0 : _b.pickNeededForBuyFeatures) {
            isPickApplicableToSelectedFeatureBuy = NolimitPromotionPlugin_1.NolimitPromotionPlugin.ASOptionsData.bonusGame.pickNeededForBuyFeatures.indexOf(featureData.name) > -1;
        }
        const pickMode = this._controller.actionSpinsController.view.gameOptionsView.selectedOptions.get(ASEnums_1.ASBonusPickOptions.PICK_MODE);
        if (pickMode && isPickApplicableToSelectedFeatureBuy) {
            popUpData.options.push(pickMode);
        }
        this._controller.promotionPlugin.view.popUpView.openActionSpins((button, featureData) => this._controller.buttonClick(button, featureData), popUpData);
    }
    closePopUp() {
        this._controller.promotionPlugin.view.popUpView.close();
    }
    show() {
        super.show();
    }
    hide() {
        super.hide();
    }
    updateFeaturePrice(currentBet) {
        let minPrice = Number.MAX_VALUE;
        this._featureBuyTickets.forEach((gameFeatureView) => {
            gameFeatureView.updatePrice(currentBet);
            minPrice = Math.min(minPrice, gameFeatureView.price);
        });
        return minPrice;
    }
    getNextBetMinFeaturePrice(nextCurrentBet, currentSpinCount) {
        let nextMinFeaturePrice = Number.MAX_VALUE;
        this._featureBuyTickets.forEach((gameFeatureView) => {
            gameFeatureView.updateNextBetPrice(nextCurrentBet, currentSpinCount);
            nextMinFeaturePrice = Math.min(nextMinFeaturePrice, gameFeatureView.nextBetPrice);
        });
        return nextMinFeaturePrice;
    }
    onResize() {
        if (this._isOpen) {
            const bounds = NolimitApplication_1.NolimitApplication.screenBounds;
            const isLandscape = NolimitApplication_1.NolimitApplication.isLandscape && Helper_1.Helper.isDefaultScreenRatio(bounds);
            const newScrollRect = new PIXI.Rectangle(PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT, 0, bounds.width - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT, bounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - 1);
            if (isLandscape) {
                // this._featureContainer.y = 538;
            }
            else if (NolimitApplication_1.NolimitApplication.isLandscape && !Helper_1.Helper.isDefaultScreenRatio(bounds)) {
                // this._featureContainer.y = 538;
            }
            else {
                //this._featureContainer.y = 538;
                const topBarHeight = ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.TOP_BAR).height - 10;
                newScrollRect.width = bounds.width;
                newScrollRect.height = bounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - topBarHeight - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT;
                newScrollRect.x = 0;
                newScrollRect.y = topBarHeight;
            }
            // this.position.set(0, 0);
            const landscapeLayout = NolimitApplication_1.NolimitApplication.isLandscape && Helper_1.Helper.isDefaultScreenRatio(bounds);
            this._featureBuyTickets.forEach((gameFeatureView) => {
                gameFeatureView.resize(landscapeLayout);
            });
            const freeWidth = newScrollRect.width;
            let yAdvance = 0;
            for (let ticket of this._featureBuyTickets) {
                ticket.x = (freeWidth - ticket.width) * 0.5;
                ticket.y = yAdvance;
                yAdvance += ticket.height - 3;
            }
        }
    }
}
exports.ActionSpinsBuyFeatureView = ActionSpinsBuyFeatureView;
//# sourceMappingURL=ActionSpinsBuyFeatureView.js.map